export enum HeaderTabFields {
  userReferenceNumber = 'userReferenceNumber',
  typeOfUse = 'typeOfUse',
  countryOfDestinationCode = 'countryOfDestinationCode',
  placeOfLoadingCode = 'placeOfLoadingCode',
  placeOfUnloadingCode = 'placeOfUnloadingCode',
  ogaOperation = 'ogaOperation',
  id = 'id',
  status = 'status',
  licenseType = 'licenseType',
  approvalReference = 'approvalReference',
  approvalDate = 'approvalDate',
  requestNumber = 'requestNumber',
  requestDate = 'requestDate',
  validFrom = 'validFrom',
  validTo = 'validTo',
  countryOfDestinationName = 'countryOfDestinationName',
  placeOfLoadingName = 'placeOfLoadingName',
  placeOfUnloadingName = 'placeOfUnloadingName',
  invoiceCurrencyCode = 'invoiceCurrencyCode',
  invoiceCurrencyName = 'invoiceCurrencyName',
  invoiceExchangeRate = 'invoiceExchangeRate',
  invoiceAmountInNationalCurrency = 'invoiceAmountInNationalCurrency',
  invoiceAmountInForeignCurrency = 'invoiceAmountInForeignCurrency',
  termsOfDeliveryCode = 'termsOfDeliveryCode',
  termsOfDeliveryDescription = 'termsOfDeliveryDescription',
  ministryCode = 'ministryCode',
  customsOfficeCode = 'customsOfficeCode',
  customsOfficeName = 'customsOfficeName',
  departmentOfficeCode = 'departmentOfficeCode',
  departmentOfficeName = 'departmentOfficeName',
  relatedProducts = 'relatedProducts',
  flow = 'flow',
  extendTo = 'extendTo',
  numberOfDays = 'numberOfDays',
}

export enum NamesAndPartiesTabFields {
  companyCode = 'companyCode',
  companyPhone = 'companyPhone',
  companyEmail = 'companyEmail',
  declarantCode = 'declarantCode',
  declarantName = 'declarantName',
  companyDescription = 'companyDescription',
  companyAddress = 'companyAddress',
  exporterNameAndAddress = 'exporterNameAndAddress',
}

export enum ConsignmentTabFields {
  transitCountryCode = 'transitCountryCode',
  transitCountryName = 'transitCountryName',
  firstPointOfArrival = 'firstPointOfArrival',
  meanOfTransportCode = 'meanOfTransportCode',
  meanOfTransportName = 'meanOfTransportName',
  transportMeansOfIdentity = 'transportMeansOfIdentity',
  voyageNumber = 'voyageNumber',
}

export enum ItemsTabFields {
  id = 'id',
  parentItemId = 'parentItemId',
  commodityCode = 'commodityCode',
  commodityDescription = 'commodityDescription',
  commercialDescription = 'commercialDescription',
  manufacturerName = 'manufacturerName',
  countryOfOriginCode = 'countryOfOriginCode',
  countryOfOriginName = 'countryOfOriginName',
  packageNumber = 'packageNumber',
  packageTypeCode = 'packageTypeCode',
  packageTypeName = 'packageTypeName',
  packageMark = 'packageMark',
  grossMass = 'grossMass',
  netMass = 'netMass',
  quotaType = 'quotaType',
  quotaType2 = 'quotaType2',
  requestedAmount = 'requestedAmount',
  approvedAmount = 'approvedAmount',
  remainingAmount = 'remainingAmount',
  requestedAmount2 = 'requestedAmount2',
  approvedAmount2 = 'approvedAmount2',
  remainingAmount2 = 'remainingAmount2',
  itemInvoiceAmountInForeignCurrency = 'itemInvoiceAmountInForeignCurrency',
  itemInvoiceAmountInNationalCurrency = 'itemInvoiceAmountInNationalCurrency',
  requestedUomCode = 'requestedUomCode',
  requestedUomCode2 = 'requestedUomCode2',
  requestedUomName = 'requestedUomName',
  requestedUomName2 = 'requestedUomName2',
  approvedUomCode = 'approvedUomCode',
  approvedUomCode2 = 'approvedUomCode2',
  approvedUomName = 'approvedUomName',
  approvedUomName2 = 'approvedUomName2',
  packages = 'packages',
  treatments = 'treatments',
}

export enum PackageFields {
  id = 'id',
  packageCode = 'packageCode',
  packageName = 'packageName',
  packageQuantity = 'packageQuantity',
  numberOfNaturePackages = 'numberOfNaturePackages',
}

export enum TreatmentFields {
  id = 'id',
  validFrom = 'validFrom',
  validTo = 'validTo',
  typeCode = 'typeCode',
  typeName = 'typeName',
  accuracyCode = 'accuracyCode',
  accuracyName = 'accuracyName',
  chemicalCode = 'chemicalCode',
  chemicalName = 'chemicalName',
  duration = 'duration',
  temperature = 'temperature',
  concentration = 'concentration',
  additionalInformation = 'additionalInformation',
}

export enum BeneficiaryFields {
  id = 'id',
  code = 'code',
  description = 'description',
  phoneNumber = 'phoneNumber',
  email = 'email',
}

export enum FeeFields {
  id = 'id',
  receiptNumber = 'receiptNumber',
  paymentDate = 'paymentDate',
  billNumber = 'billNumber',
  invoiceDate = 'invoiceDate',
}

export enum FeeTabFields {
  totalAmount = 'totalAmount',
  amountToBePaid = 'amountToBePaid',
  paidAmount = 'paidAmount',
}

export enum AttachedDocumentsTabFields {
  id = 'id',
  code = 'code',
  name = 'name',
  referenceNumber = 'referenceNumber',
  attachmentDate = 'attachmentDate',
  fileUrl = 'fileUrl',
}

export enum ArrayFields {
  items = 'items',
  beneficiaries = 'beneficiaries',
  attachedDocuments = 'attachedDocuments',
  fees = 'fees',
  packages = 'packages',
  treatments = 'treatments',
}

export const additionalFields = 'additionalFields';
export const dbOptionAdditionalFields = 'dbOptionAdditionalFields';

export const supportInfoMessage = 'supportInfoMessage';
